import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import EndOfScrollComponent from "./components/common/AdventureScroll.jsx";
import MotorcycleHero from "./components/non-logged-in/MotorcycleHero.jsx";
import MotorcycleMapCard from "./pages/MapCardPage/MotorcycleMapCard.jsx";

import BannerNonLogin from "./components/non-logged-in/Banner.jsx";
import BannerAem from "./pages/LoggedInPage/BannerAem.jsx";
import UpcomingRidesAem from "./pages/LoggedInPage/UpcomingRidesAem.jsx";
//import RidesAem from "./components/non-logged-in/RidesAem.jsx";
import Customizer from "./components/common/MotorcycleCustomizer.jsx";

const App = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Route for guest homepage */}
        <Route
          path="/"
          element={
            <main className="overflow-hidden">
              <section>
                <BannerNonLogin />
              </section>
              <section>
                <MotorcycleHero />
              </section>
              <section>
                <Customizer />
              </section>
              <section>
                <UpcomingRidesAem />
              </section>
              <section>
                <EndOfScrollComponent />
              </section>
            </main>
          }
        />

        {/* Route for map card */}
        <Route path="/map" element={<MotorcycleMapCard />} />

        {/* Route for logged-in users */}
        <Route
          path="/loggedin"
          element={
            <main className="p-0 m-0">
              <section className="space-y-0">
                <BannerAem />
                <Customizer />
                <UpcomingRidesAem />
                <EndOfScrollComponent />
              </section>
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
